<!--Copyright (c) Laserfiche.
Licensed under the MIT License. See LICENSE in the project root for license information.-->

<p class="documentation-title">Laserfiche UI Components</p>

<p class="documentation-text">
  The Laserfiche UI Components project is a collection of reusable web components that are available as
  framework-agnostic custom elements. The UI components include out-of-the-box Laserfiche experiences (e.g. document
  view, search, and import) as well as lower-level base components (e.g. trees, fields, etc.).
</p>

<p class="documentation-text">
  The Laserfiche UI Components makes it easy for you to integrate Laserfiche experiences into your application with
  minimal code.
</p>

<app-card>
  <div>
    <lf-field-container #overviewField [collapsible]="true"></lf-field-container>
  </div>
</app-card>

<p class="documentation-header">Who should use the Laserfiche UI Components?</p>

<p class="documentation-text">
  The Laserfiche UI Components is intended for developers and integrators looking for an easy way to connect to
  Laserfiche in their web applications.
</p>

<p class="documentation-header">Supported browsers</p>

<div title="chrome" class="browser chrome-logo"></div>
<div title="firefox" class="browser firefox-logo"></div>
<div title="edge" class="browser edge-logo"></div>

<p class="documentation-header">Feedback</p>

<p class="documentation-text">
  For questions and feature requests, feel free to contact us at
  <strong>e-eng-application-components&#64;laserfiche.com</strong>
</p>
